import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=6cd1cbe0&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=6cd1cbe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd1cbe0",
  null
  
)

component.options.__file = "orderDetails.vue"
export default component.exports